import { useEffect, useState } from 'react';
import { api } from '../../../api.ts';

interface HistoryEntry {
  id: string;
  status: 'published' | 'archived';
  note: string | null;
  created_at: string;
  first_name: string | null;
  last_name: string | null;
}

export function HistorySection({ onRestored }: { onRestored: () => void }) {
  const [history, setHistory] = useState<HistoryEntry[] | null>(null);
  const [restoring, setRestoring] = useState<string | null>(null);

  function load() {
    api.get<{ history: HistoryEntry[] }>('/site-content/history').then((res) => setHistory(res.history));
  }

  useEffect(load, []);

  async function restore(id: string) {
    if (!window.confirm('Restaurer cette version ? Elle sera immédiatement republiée.')) return;
    setRestoring(id);
    try {
      await api.post(`/site-content/restore/${id}`);
      load();
      onRestored();
    } finally {
      setRestoring(null);
    }
  }

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Historique des publications</h2>
      {!history && <div className="empty-state">Chargement…</div>}
      {history?.length === 0 && <div className="empty-state">Aucune publication pour l'instant.</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {history?.map((entry) => (
          <div key={entry.id} className="card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
            <div>
              <div style={{ fontWeight: 700, fontSize: 13.5 }}>
                {new Date(entry.created_at).toLocaleString('fr-FR')}
                {entry.status === 'published' && (
                  <span className="badge badge-available" style={{ marginLeft: 8 }}>Publiée actuellement</span>
                )}
              </div>
              <div style={{ fontSize: 12.5, color: 'var(--text-secondary)' }}>
                {entry.note || 'Sans description'}
                {entry.first_name ? ` · par ${entry.first_name} ${entry.last_name ?? ''}` : ''}
              </div>
            </div>
            {entry.status !== 'published' && (
              <button
                type="button"
                className="btn btn-secondary"
                style={{ width: 'auto', padding: '8px 14px' }}
                onClick={() => restore(entry.id)}
                disabled={restoring === entry.id}
              >
                {restoring === entry.id ? 'Restauration…' : 'Restaurer cette version'}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
